import { atomWithReset } from 'jotai/utils';
import type { AttemptErrorAction } from '@/lib/ielts-attempt-error';
import type { RouteSkill } from '@/lib/routes';

export interface IeltsAttemptErrorState {
  /** Suffix under `ielts:error.attempt.*`, e.g. `already_submitted`. */
  i18nKey: string;
  action: AttemptErrorAction;
  skill: RouteSkill;
  attemptId?: string;
  /** Where `back` / `restart` lands. Defaults to the skill's test list. */
  backHref?: string;
}

/**
 * The blocking attempt error currently on screen, if any.
 *
 * `useIeltsAttemptError` is instantiated by several components per exam screen
 * (the answer inputs, the side panel, the footer), so the error is raised in one
 * place and rendered in another. Keeping it in an atom lets whichever component
 * hits the error hand it to the single `IeltsAttemptErrorModals` mounted in `_app`.
 */
export const ieltsAttemptErrorAtom = atomWithReset<IeltsAttemptErrorState | null>(null);

/** Set when the gamification theme's own login prompt should be shown instead. */
export const ieltsRequireLoginAtom = atomWithReset(false);
